export default __webpack_public_path__ + "static/desktop_sek2_KV07-008686c7fa238e591b613eba6dd84136.mp4";